<template>
	<div class="slideshow">
		<div class="boat__slider" @dragstart="startDrag" @dragend="stopDrag" @drag="" @touchstart.prevent="startDrag" @touchmove="" @touchend.prevent="stopDrag" draggable="true">
			<transition name="fade" mode="out-in">
				<div class="slide" v-for="(img, i) in images" :key="'slide-' + i" v-if="index === i" :style="{'background-image': 'url(' + img + ')'}"></div>
			</transition>
		</div>
		<div class="boat__gallery" v-if="thumbs && thumbs.length > 1">
			<div class="slide" v-for="(thumb, i) in thumbs" @click.prevent="doTimeout(); index = i" :key="'thumb-' + i" :class="{active: i === index}">
				<img :src="thumb" alt="Boat Image">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['thumbs', 'images'],
		data() {
			return {
				index: 0,
				timeout: null,
				startX: 0
			};
		},
		methods: {
			startDrag(event) {
				if(event.dataTransfer) {
					const div = document.createElement('div');
					event.dataTransfer.setDragImage(div, 0, 0);
				}
				clearTimeout(this.timeout);
				this.startX = ((event.changedTouches)?event.changedTouches[0].clientX:event.clientX);
			},
			stopDrag(event) {
				if(((event.changedTouches)?event.changedTouches[0].clientX:event.clientX) - this.startX < -100) {
					this.nextSlide();
				}
				if(((event.changedTouches)?event.changedTouches[0].clientX:event.clientX) - this.startX > 100) {
					this.previousSlide();
				}
			},
			nextSlide() {
				this.doTimeout();
				this.index++;
				if(this.index > this.images.length - 1) {
					this.index = 0;
				}
			},
			previousSlide() {
				this.doTimeout();
				this.index--;
				if(this.index < 0) {
					this.index = this.images.length - 1;
				}
			},
			doTimeout() {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(this.nextSlide.bind(this), 3000);
			}
		},
		created() {
			if(typeof(window) === 'undefined') {
				return;
			}
			this.timeout = setTimeout(this.nextSlide.bind(this), 3000);
		},
		destroyed() {
			clearTimeout(this.timeout);
			this.timeout = null;
		}
	}
</script>
